import {FC} from 'react';
import {Box, Flex} from '@chakra-ui/react';
import {IMemoryFact, getDateTimeString} from '@kcast-fe/core';
import {useScreenSize} from 'ui-kit';

interface IProps {
  fact: IMemoryFact;
}

const MemoryFactItemFC: FC<IProps> = ({fact}) => {
  const {isLessThan768} = useScreenSize();

  return (
    <Flex
      direction={'column'}
      gap={'4px'}
      p={isLessThan768 ? '12px 0 8px 0' : '12px 0'}
      borderBottom={'thin solid'}
      borderColor={'{colors.borderDefault}'}
    >
      <Box color={'{colors.textPrimary}'}>{fact.fact}</Box>
      <Box fontSize={'12px'} color={'{colors.textTertiary}'}>
        {getDateTimeString(fact.created_at, true)}
      </Box>
    </Flex>
  );
};

export const MemoryFactItem = MemoryFactItemFC;
